/*********************************************************
 * Third Controls
*********************************************************/
import React, { useEffect, Fragment, useState } from "react";
import { injectIntl } from "react-intl";
import { connect, useSelector, useDispatch } from 'react-redux';
import { Grid } from '@mui/material';
import cx from 'classnames';

/*********************************************************
 * Actions
*********************************************************/
import {
  selectModuleMapSettings,
  updateShowVehicleTrails,
  selectCreateClickMapType,
  drawGetDirections,
  setShowMapSettings,
  addPointers,
  getRoutesResponse,
  updateShowVehicleTrailsSettings,
  setLatLng,
  setListUnits,
  vicinityToolSetField
} from "Redux/actions";

/*********************************************************
 * Controls
*********************************************************/
import SidePanel, { SidePanelBody, SidePanelHeader, SidePanelFooter } from 'Components/SidePanel';
import { MapUtilitiesTypes } from './enums';
import { TypeObjectMap } from 'Components/Map/providers/enums'
import { HasPermission } from 'Core/security';
import VehicleList from '../VehicleList'
import VehicleTrails from '../VehicleTrails'
/* import LandmarksListMain from '../LandmarksListMain' */
import Landmarks from '../landmarks'
import Routes from '../routes';
/* import GeofenceListMain from '../GeofenceListMain' */
import Geofences from '../geofences'
import SendMessage from '../SendMessage'
import LayerMap from '../LayerMap'
import VehicleDirections from '../VehicleDirections'
import Eta from '../eta'
import SpeedOverride from '../speedOverride'
import VicinityTool from '../vicinityTool'
import { TypeLayer } from 'Components/Map/providers/enums'
import FindNearest from '../findNearest';
import { IconButton, Icon } from '@mui/material';
import { Tooltip, Button } from 'Components';
// Panel-modal registry imports — add new modal actions here as named imports
import {
  minimizeModal as minimizeDeleteRoutesModal,
  restoreModal as restoreDeleteRoutesModal
} from 'Modules/routes/views/templates/components/deleteRoute/redux/slice';
import UnitSelection from '../UnitSelection';
import MapSetting from '../MapSetting';
import TagFilterAppliedMenu  from '../TagFilterAppliedMenu';

/*********************************************************
 * Styles
*********************************************************/
import './style.scss';
import TrailsTripMode from "../VehicleTrails";

/******************************************************************
 * Define show or not the option on menu
 * @param {MapUtilitiesTypes} type 
 * @param {Object} user 
 * @param {Object} messages 
 ******************************************************************/
const typeMenuName = (type, user, messages, vicinityToolStep) => {
  let valueMenu = '';

  switch (type) {

    case MapUtilitiesTypes.Vehicles:
      valueMenu = messages['maputilities_vehicles'];
      break;

    /* case MapUtilitiesTypes.RealtimeMaps:
      valueMenu = messages['maputilities_realtimemaps'];
      break; */

    case MapUtilitiesTypes.VehicleTrails:
      if (HasPermission(user, '', [32])) {
        valueMenu = messages['maputilities_vehicletrails'];
      }
      break;

    case MapUtilitiesTypes.Landmarks:
      if (HasPermission(user, '', [3])/*  || HasPermission(user, '', [4]) */) {
        valueMenu = messages['maputilities_landmarks'];
      }
      break;

    case MapUtilitiesTypes.Geofences:
      if (HasPermission(user, '', [1])) {
        valueMenu = messages['maputilities_geofences'];
      }
      break;

    case MapUtilitiesTypes.RouteMaker:
      if (HasPermission(user, '', [36])) {
        valueMenu = messages['maputilities_routemarker'];
      }
      break;

    case MapUtilitiesTypes.VehicleDirections:
      if (HasPermission(user, '', [101])) {
        valueMenu = messages['maputilities_vehicledirections'];
      }
      break;

    case MapUtilitiesTypes.FindNearest:
      if (HasPermission(user, '', [102])) {
        valueMenu = messages['maputilities_findnearest'];
      }
      break;

    case MapUtilitiesTypes.SendSMS:
      if (HasPermission(user, '', [34])) {
        valueMenu = messages['maputilities_sendsms'];
      }
      break;

    case MapUtilitiesTypes.MapSettings:
      if (HasPermission(user, '', [5])) {
        valueMenu = messages['maputilities_mapsettings'];
      }
      break;
      
    case MapUtilitiesTypes.TagFilter:
        valueMenu = messages['maputilities_tagsFilterOnMap'];
        break;

    /* case MapUtilitiesTypes.GoogleEarth: 
        if(HasPermission(user, 'kml', [11]) || HasPermission(user, 'kml', [35])){
          valueMenu = messages['maputilities_googleearth'];
        }
        break;

    case MapUtilitiesTypes.Video: 
        valueMenu = messages['maputilities_video'];
        break; */

    case MapUtilitiesTypes.LayerMap:
      valueMenu = 'Layer Map';
      break;

    case MapUtilitiesTypes.UnitSelection:
      //valueMenu = 'Unit Selection'
      break

    case MapUtilitiesTypes.Eta:
      //if (HasPermission(user, '', [231])) {
      if (HasPermission(user, 'etalink', [231])) {
        valueMenu = messages['maputilities_eta'];
      }
      break;

    case MapUtilitiesTypes.SpeedOverride:
      if (HasPermission(user, 'speedov', [234])) {
        valueMenu = messages['maputilities_speedOverride'];
      }
      break;

    case MapUtilitiesTypes.VicinityTool:
      if (HasPermission(user, 'vctl', [268])) {
        valueMenu = vicinityToolStep === "units" ? messages['maputilities_vicinityToolUnits'] : messages['maputilities_vicinityTool']
      }
      break;
  }

  return valueMenu;
}

/******************************************************************
 * Return the control to the view 
 ******************************************************************/
const Control = ({ type, messages, props, onShowMapSettings, onClickSettings }) => {


  switch (type) {

    case MapUtilitiesTypes.Vehicles:
      return (<VehicleList mapRef={props.mapRef} />)

    case MapUtilitiesTypes.VehicleTrails:
      return (<TrailsTripMode mapRef={props.mapRef}  onClickSettings={onClickSettings} />)

    case MapUtilitiesTypes.Landmarks:
      return (<Landmarks messages={messages} mapRef={props.mapRef} />);
    /* return (<LandmarksListMain messages={messages} mapRef={props.mapRef} />) */

    case MapUtilitiesTypes.SendSMS:
      return (<SendMessage messages={messages} />)

    case MapUtilitiesTypes.LayerMap:
      return (<LayerMap messages={messages} onShowMapSettings={onShowMapSettings} mapRef={props.mapRef} />)


    case MapUtilitiesTypes.MapSettings:
      return (<MapSetting messages={messages} mapRef={props.mapRef} onShowMapSettings={onShowMapSettings} />)

    case MapUtilitiesTypes.TagFilter:
      return (<TagFilterAppliedMenu messages={messages} mapRef={props.mapRef} onShowMapSettings={onShowMapSettings} />)

    case MapUtilitiesTypes.Geofences:
      return (<Geofences messages={messages} mapRef={props.mapRef} />)
    /* return (<GeofenceListMain messages={messages} mapRef={props.mapRef} />) */

    case MapUtilitiesTypes.VehicleDirections:
      return (<VehicleDirections messages={messages} mapRef={props.mapRef} />)

    case MapUtilitiesTypes.RouteMaker:
      return (<Routes mapRef={props.mapRef} />)

    case MapUtilitiesTypes.FindNearest:
      return (<FindNearest mapRef={props.mapRef} />);

    /*
    case MapUtilitiesTypes.GoogleEarth:
    case MapUtilitiesTypes.Video:
      return (<Fragment><p>module here...</p></Fragment>) */

    case MapUtilitiesTypes.UnitSelection:
    case MapUtilitiesTypes.UnitSelectionModal:
      return (<UnitSelection messages={messages} mapRef={props.mapRef} />)

    case MapUtilitiesTypes.Eta:
      return (<Eta messages={messages} mapRef={props.mapRef} />)

    case MapUtilitiesTypes.SpeedOverride:
      return (<SpeedOverride mapRef={props.mapRef} />)

    case MapUtilitiesTypes.VicinityTool:
      return (<VicinityTool mapRef={props.mapRef} />)
  }
  return (<Fragment></Fragment>)
}

/*********************************************************
 * Item menu elements
*********************************************************/
const ItemMenu = ({ id, type, user, messages, selectModuleMapSettings, loading }) => {

  let valueMenu = typeMenuName(type, user, messages);
  if (valueMenu == '') {
    return (<Fragment />)
  }

  return (
    <Grid item xs={12} className={`${id}`}>
      <label
        className={`menuItem ${loading && type === MapUtilitiesTypes.Vehicles ? 'menuItem-disabled' : ''}`}
        onClick={() => {
          if (selectModuleMapSettings) {
            if (type === MapUtilitiesTypes.Vehicles && !loading) {
              selectModuleMapSettings(type);
            } else if (type !== MapUtilitiesTypes.Vehicles) {
              selectModuleMapSettings(type);
            }
          }
        }} >
        {valueMenu}
      </label>
    </Grid>
  )
}

/*********************************************************
 * Back button on top at the control
*********************************************************/
const BackButton = ({
  value,
  selectModuleMapSettings,
  currentModule,
  updateShowVehicleTrails,
  selectCreateClickMapType,
  drawGetDirections,
  addPointers,
  getRoutesResponse,
  mapRef,
  updateShowVehicleTrailsSettings,
  setLatLng,
  vicinityToolStep,
  vicinityToolSetField,
  vicinityToolResult
}) => {
  return (
    <label
      className={'menuItem'}
      onClick={() => {
        if(currentModule == MapUtilitiesTypes.VicinityTool && vicinityToolStep === "settings"){
          vicinityToolSetField({ inicialState: true, shape: null });
          mapRef?.current?.removeLayer(TypeLayer?.PolygonCreate);
          mapRef?.current?.removeLayer(TypeLayer?.CircleCreate);
          mapRef?.current?.removeLayer(TypeLayer?.SquareCreate);
        }
        if (currentModule == MapUtilitiesTypes.VicinityTool && vicinityToolStep === "units") {
          mapRef.current.removeLayer(TypeLayer?.VicinityTool);
          vicinityToolSetField({ step: "settings", result: [], initialShape: true });
          return
        }
        if (currentModule === MapUtilitiesTypes.VehicleTrails && vicinityToolResult.length) {
          updateShowVehicleTrails(false);
          updateShowVehicleTrailsSettings(false);
          mapRef.current.removeLayer(TypeLayer.VehicleTrails);
          mapRef.current.removeLayer(TypeLayer.VicinityTool);
          mapRef.current.removeLayer(TypeLayer.VehicleTrailsTrailHistory);
          selectModuleMapSettings(MapUtilitiesTypes.VicinityTool);
          vicinityToolSetField({ showNewLayer: true });
          return
        }
        updateShowVehicleTrailsSettings(false) //Set the settings button in false
        //Unload vehicle trails module
        if (currentModule == MapUtilitiesTypes.VehicleTrails && updateShowVehicleTrails) {
          mapRef?.current?.showVehicleTrails(false); // restore WebGL layer, units, labels & clusters
          mapRef?.current?.hideMarkerModal();
          mapRef?.current?.removeLayer(TypeLayer.VehicleTrails);
          mapRef?.current?.removeLayer(TypeLayer.VehicleTrailsTrailHistory);
          updateShowVehicleTrails(false);
        }

        //Unload create geofence or circle
        if (currentModule == MapUtilitiesTypes.Geofences || currentModule == MapUtilitiesTypes.Landmarks) {
          selectCreateClickMapType(TypeObjectMap.Default)
          mapRef.current.removeLayer(TypeLayer.TemporalObjects);
          setLatLng(null)
        }

        if (currentModule == MapUtilitiesTypes.VehicleDirections) {
          drawGetDirections(false)
          addPointers([])
          selectCreateClickMapType(TypeObjectMap.Default)
          setLatLng(null)
        }

        if (selectModuleMapSettings) {
          selectModuleMapSettings(MapUtilitiesTypes.Default)
        }

        if (currentModule == MapUtilitiesTypes.RouteMaker) {
          getRoutesResponse({ items: [], total: 0 });
          drawGetDirections(false)
        }

        if (currentModule == MapUtilitiesTypes.Eta) {
          mapRef.current.showVehicleTrails(false)
        }
        //show the units in map again for preferences
        mapRef?.current?.showUnitsByPreferences(
          currentModule == MapUtilitiesTypes.VehicleTrails
            ? { centerOnPreferences: false }
            : undefined
        );

      }} >
      {value}
    </label>
  );
}

/*********************************************************
 * Author:  Walter Paz Londoño
 * Date:    24 Dic 2020
 * Module:  Realtime Maps
 * 
 * Class associated to the VehicleTrails elements - MapUtilitiesMenu
 ********************************************************/
const MapUtilitiesMenu = (props) => {
  const { loading, currentModule, intl, user, selectModuleMapSettings,
    setShowMapSettings, showMapSettings, mapRef, setListUnits, vicinityToolStep } = props

  const { messages } = intl;

  const dispatch = useDispatch();

  // ─────────────────────────────────────────────────────────────────────────
  // Panel-modal registry. To support a new modal:
  //   1. Import its minimizeModal / restoreModal actions above (with alias)
  //   2. Append a new entry to this array
  // Note: minimize/restore are dispatched blindly on panel toggle — no need
  // to observe modal state here (avoids cascading re-renders into Routes).
  // ─────────────────────────────────────────────────────────────────────────
  const panelModals = [
    {
      minimize: () => dispatch(minimizeDeleteRoutesModal()),
      restore: () => dispatch(restoreDeleteRoutesModal()),
    },
  ];

  const onShowMapSettings = () => {
    if (currentModule === MapUtilitiesTypes.UnitSelection || currentModule === MapUtilitiesTypes.UnitSelectionModal) {
      selectModuleMapSettings(MapUtilitiesTypes.Default);
      removePolygon();
    }
    if (showMapSettings) {
      panelModals.forEach(({ minimize }) => minimize());
    }
    setShowMapSettings(!showMapSettings)
  }

  useEffect(() => {
    return () => {
      selectModuleMapSettings(MapUtilitiesTypes.Default)
    }
  }, []);

  useEffect(() => {
    if (!showMapSettings && currentModule === 13) {
      selectModuleMapSettings(0);
    } else if (currentModule !== MapUtilitiesTypes.UnitSelection || currentModule !== MapUtilitiesTypes.UnitSelectionModal) {
      removePolygon();
    }
  }, [currentModule, showMapSettings]);

  useEffect(() => {
    if (showMapSettings) {
      panelModals.forEach(({ restore }) => restore());
    }
  }, [showMapSettings]);

  const ShowItemMenu = ({ id, type }) => {
    return (
      <ItemMenu
        id={id}
        loading={loading}
        type={type}
        user={user}
        messages={messages}
        selectModuleMapSettings={selectModuleMapSettings}
      />
    )
  }

  const ShowItemDetail = (props) => {
    return (
      <SidePanelBody className={cx('side-panel-body-realtime', currentModule === (MapUtilitiesTypes.SendSMS || MapUtilitiesTypes.Landmarks || MapUtilitiesTypes.Geofences) && 'side-panel-send-message')}>
        <Grid
          style={currentModule != MapUtilitiesTypes.VehicleTrails ? { paddingLeft: 20, paddingTop: 20, width: '100%' } : { paddingLeft: 20, paddingTop: 0, width: '100%' }}
          container
          direction="row"
          justifyContent="space-between"
          alignItems="center"
          spacing={1}>
          <Grid item xs={12} >
            {
              props.children
            }
          </Grid>
        </Grid>
      </SidePanelBody>
    )
  }

  const onClickSettings = (id) => {
    if (currentModule == MapUtilitiesTypes.VehicleTrails) {
      if (props.updateShowVehicleTrailsSettings) {
        props.updateShowVehicleTrailsSettings(true)
      }
    }
    if (currentModule == MapUtilitiesTypes.RouteMaker) {
      if (id == 'menu_delete' && props.updateShowVehicleTrailsSettings) {
        //props.updateShowVehicleTrailsSettings(true)
      }
    }
  }

  const removePolygon = () => {
    if (!mapRef?.current) return;
    mapRef.current.removeMapObject('drawn_polygon', TypeObjectMap.Polygon);
    mapRef.current.removeMapDraw();
    setListUnits([], false);
  }

  const HiddenHeader = [
    MapUtilitiesTypes.UnitSelection,
    MapUtilitiesTypes.UnitSelectionModal,
    MapUtilitiesTypes.LayerMap,
    MapUtilitiesTypes.MapSettings,
    MapUtilitiesTypes.TagFilter
  ]

  const ButtonMenuSettings = (props) => {

    return (
      <div className={'butSettingsMenu'}>
        <Tooltip title={props.title} placement={'top-start'}>
          <IconButton
            aria-haspopup="true"
            onClick={() => { onClickSettings(props?.id) }}
            color={"inherit"}
            size="large">
            {
              props.nameIcon
              &&
              <Icon style={props.color && { color: `${props.color}` }}>{props.nameIcon}</Icon>
            }
            {
              props.icon
              &&
              <Fragment>
                {props.icon}
              </Fragment>
            }
          </IconButton>
        </Tooltip>
      </div>
    );
  }

  return (
    <Fragment>
      <SidePanel
        classPanelContent='side-panel-content-realtime'
        classSidePanel={showMapSettings && 'class-panel-map'}
        style={{ zIndex: 2 }}
        isOpen={showMapSettings}
        toggle={() => onShowMapSettings()}>
        <SidePanelHeader>
          {!HiddenHeader.includes(currentModule) && (
            <div style={{ paddingLeft: 20, overflow: 'hidden' }}>
              <Grid container direction="row" justifyContent="space-between" alignItems="center" spacing={3}>
                <Grid item xs={12}>
                  <h2 style={{ margin: 0, color: '#333333' }}>{messages['maputilities_menutitle']}</h2>
                </Grid>
                <Grid item xs={12}>
                  {
                    currentModule != MapUtilitiesTypes.Default
                    &&
                    <div>
                      <BackButton
                        value={messages['maputilities_back']}
                        {...props}
                        updateShowVehicleTrailsSettings={props.updateShowVehicleTrailsSettings}
                      />
                    </div>
                  }
                </Grid>
                {
                  ( currentModule != MapUtilitiesTypes.Default  &&
                    currentModule != MapUtilitiesTypes.Vehicles  &&
                    currentModule != MapUtilitiesTypes.RouteMaker) &&
                    currentModule != MapUtilitiesTypes.VehicleTrails
                  &&
                  <Grid item xs={8}>
                    <h3 style={{ margin: 0 }}>{typeMenuName(currentModule, user, messages, vicinityToolStep)}</h3>
                  </Grid>
                }
                {
                  currentModule == MapUtilitiesTypes.RouteMaker
                  &&
                  <div style={{ paddingBottom: 10 }}></div>
                }
                {
                  //Add the modules in this place to use settings in menu items
                  currentModule == MapUtilitiesTypes.VehicleTrails && null
                }
              </Grid>
            </div>
          )}
          {
            (currentModule === MapUtilitiesTypes.UnitSelection || currentModule === MapUtilitiesTypes.UnitSelectionModal) &&
            <div style={{ paddingLeft: 20, overflow: 'hidden' }}>
              <Grid container direction="row" justifyContent="space-between" alignItems="center" spacing={3}>
                <Grid item xs={10}>
                  <h2 style={{ margin: 0, color: '#333333' }}>{currentModule === MapUtilitiesTypes.UnitSelection ? messages["mapsettings_selectedUnits"] : messages["mapsettings_selectedUnits_map"]}</h2>
                </Grid>
                <Grid item xs={2}>
                  <Button
                    type="icon"
                    icon="close"
                    className="btn-close side-panel-body-realtime-close-button"
                    onClick={(e) => {
                      removePolygon();
                      selectModuleMapSettings(0);
                    }}
                  />
                </Grid>
              </Grid>
            </div>
          }
        </SidePanelHeader>
        {
          currentModule == MapUtilitiesTypes.Default
          &&
          <SidePanelBody className='side-panel-body-realtime'>
            <div style={{ paddingLeft: 20, width: '100%' }}>
              <Grid container direction="row" justifyContent="space-between" alignItems="center" spacing={4}>
                <ShowItemMenu type={MapUtilitiesTypes.Vehicles} id="vehicles"></ShowItemMenu>
                {/* <ShowItemMenu type={MapUtilitiesTypes.RealtimeMaps} ></ShowItemMenu> */}
                <ShowItemMenu type={MapUtilitiesTypes.VehicleTrails} id="vehicle-trails"></ShowItemMenu>
                <ShowItemMenu type={MapUtilitiesTypes.Landmarks} id="landmarks"></ShowItemMenu>
                <ShowItemMenu type={MapUtilitiesTypes.Geofences} id="geofences"></ShowItemMenu>
                <ShowItemMenu type={MapUtilitiesTypes.RouteMaker} id="route-maker"></ShowItemMenu>
                <ShowItemMenu type={MapUtilitiesTypes.VehicleDirections} id="vehicle-directions"></ShowItemMenu>
                <ShowItemMenu type={MapUtilitiesTypes.FindNearest} id="find-nearest"></ShowItemMenu>
                <ShowItemMenu type={MapUtilitiesTypes.SendSMS} id="send-sms"></ShowItemMenu>
                <ShowItemMenu type={MapUtilitiesTypes.GoogleEarth} id="google-earth"></ShowItemMenu>
                <ShowItemMenu type={MapUtilitiesTypes.Video} id="video"></ShowItemMenu>
                <ShowItemMenu type={MapUtilitiesTypes.Eta} id="eta"></ShowItemMenu>
                <ShowItemMenu type={MapUtilitiesTypes.SpeedOverride} id="speedOverride"></ShowItemMenu>
                <ShowItemMenu type={MapUtilitiesTypes.VicinityTool} id="vicinityTool"></ShowItemMenu>
              </Grid>
            </div>
          </SidePanelBody>
        }

        {
          currentModule != MapUtilitiesTypes.Default
          &&
          <ShowItemDetail>
            <Control
              type={currentModule}
              messages={messages}
              props={props}
              onShowMapSettings={onShowMapSettings}
              onClickSettings={onClickSettings}
            />
          </ShowItemDetail>
        }
      </SidePanel>

    </Fragment>

  );
};

const mapStateToProps = ({ securityRedux, realtimeMapUtilitiesRedux, realtimeMapRedux, realtimeMapsVicinityTool }) => {
  const { user } = securityRedux;
  const { currentModule, showMapSettings } = realtimeMapUtilitiesRedux;
  const { loading } = realtimeMapRedux;
  const { step, result } = realtimeMapsVicinityTool;

  return {
    user,
    currentModule,
    showMapSettings,
    loading,
    vicinityToolStep: step,
    vicinityToolResult: result
  };
};

export default injectIntl(connect(mapStateToProps, {
  selectModuleMapSettings,
  updateShowVehicleTrails,
  selectCreateClickMapType,
  drawGetDirections,
  setShowMapSettings,
  addPointers,
  getRoutesResponse,
  updateShowVehicleTrailsSettings,
  setLatLng,
  setListUnits,
  vicinityToolSetField
})(MapUtilitiesMenu));